document.addEventListener("DOMContentLoaded", function () {
  
  menuHoverEvent();
  subscriptionForms();
  productMediaGallery();
  imageWithTextSection();
  imageSliderWithTextInfoSection();
  slideShowSliderSection();
  relatedBlogSlider();

  
  //outside click event
  document.onclick = function(e){
    //for address popup close event
    if(e.target.classList.contains('edit_address-overlay')){
      if(document.querySelector('.popup-active')){
        document.querySelector('.popup-active').classList.remove('popup-active');
        document.body.classList.remove('active-address-popup');
      }
    }

    //for product course dropdown close event
    if(e.target.closest('body')?.querySelector('.course-set-menu.active') && !e.target.closest('[data-category-item-list]') && !e.target.closest('.course-list-menu')){
      document.querySelector('.course-set-menu.active').classList.remove('active');
    }
  };

  //product course dropdown event
  let course_dropdown = document.querySelector('[data-category-item-list]');
  if(course_dropdown){
    course_dropdown.addEventListener('click',(e) => {
      e.preventDefault();
      e.target.closest('.course-set-menu').classList.toggle('active');
    });
  }

  //customer account page tab
  let accountTabs = document.querySelectorAll('.template-account [data-account-tabs] [data-tab]');
  if(accountTabs.length){
    // add active class to active tab based on url search param
    setTimeout(() => {
      let serachParamValue = getSeachQueryString('tab');
      if(serachParamValue){
        document.querySelector(`.template-account [data-account-tabs] [data-tab="${serachParamValue}"]`).click();  
      }
    },100);
  
    accountTabs.forEach(list => {
      list.addEventListener('click',(e) => {
        e.preventDefault();
        let currentList = e.target.closest('[data-tab]');
        let currentTabName = currentList.dataset.tab;
        e.target.closest('.account').querySelectorAll(`[data-account-tabs] [data-tab]`).forEach(li => li.classList.remove('active'));
        currentList.classList.add('active');
        if(e.target.closest('.account').querySelectorAll(`[data-account-detailes-element] [data-tab]`).length){
          e.target.closest('.account').querySelectorAll(`[data-account-detailes-element] [data-tab]`).forEach(tab => tab.classList.remove('active'));
          e.target.closest('.account').querySelector(`[data-account-detailes-element] [data-tab="${currentTabName}"]`).classList.add('active');  
        }
        //add serach param to url
        if ('URLSearchParams' in window) {
          const url = new URL(window.location);
          url.searchParams.set("tab", currentTabName);
          history.pushState(null, '', url);
        }
      });
    });
  }

  //address popup close event
  let addressPopupCloseBtn = document.querySelectorAll('.template-addresses [data-address-popup-close]');
  if(addressPopupCloseBtn.length){
    addressPopupCloseBtn.forEach(btn => {
      btn.addEventListener('click',(e) => {
        e.preventDefault();
        e.target.closest('[data-address]').querySelector('button[type="reset"]').click();
      });
    });
  }

  //about-us page smooth scroll link
  let cardImageLink = document.querySelectorAll('.template-suffix-about-us .multicolumn-college-section .grid__item .multicolumn-card-image-link');
  if(cardImageLink.length){
    cardImageLink.forEach(link => {
      link.addEventListener('click',(e) => {
        if(link.getAttribute('href').includes('#')){
          e.preventDefault();
          let linkRef = link.getAttribute('href').replace('#','');
          let element = document.querySelector(`div[id="${linkRef}"]`);
          if(element){
            let headerOffset = 75;
            let offsetPosition = element.getBoundingClientRect().top + window.pageYOffset - headerOffset;
            window.scrollTo({
             top: offsetPosition,
             behavior: "smooth"
            });
          }
        }        
      });
    });
  }

  
  //card-product-list readmore description
  let prodReadmoreEle = document.querySelectorAll('.featured-products-list-section [data-toggle-readmore]');
  if(prodReadmoreEle.length){
    prodReadmoreEle.forEach(ele => {
      ele.addEventListener('click',(e) => {
        e.preventDefault();
        const target = e.target;
        target.classList.toggle('open');
        const closestDesc = target.closest('[data-readmore-wrap]')?.querySelector('.readmore-desc');
        if(closestDesc){
          const maxHeight = closestDesc.scrollHeight;
          if(target.classList.contains('open')){
            closestDesc.style.maxHeight = `${maxHeight}px`;
          }else{
            closestDesc.style.maxHeight = "0px";
          }
        }
      });
    });
  }

  //card-product-list buy-individual-products description
  let prodBuyProductsEle = document.querySelectorAll('.featured-products-list-section [data-toggle-buy-products]');
  if (prodBuyProductsEle.length) {
    prodBuyProductsEle.forEach(ele => {
      ele.addEventListener('click', (e) => {
        e.preventDefault();
        const target = e.target;
        const wrap = target.closest('[data-buy-products-wrap]');
        const desc = wrap?.querySelector('.buy-products-desc');

        if (desc) {
          const isOpen = target.classList.toggle('open');
          if (isOpen) {
            desc.classList.add('show');
            desc.style.maxHeight = `${desc.scrollHeight}px`;
          } else {
            desc.style.maxHeight = '0px';
            desc.classList.remove('show');
          }
        }
      });
    });
  }
  
  //mix-match collection template complementry prod deatils description slide-up/down
  let cmplProdDetailesEle = document.querySelectorAll('.template-suffix-mix-and-match-bundle [data-toggle-details]');
  if(cmplProdDetailesEle.length){
    cmplProdDetailesEle.forEach(ele => {
      ele.addEventListener('click',(e) => {
        e.preventDefault();
        const target = e.target;
        target.classList.toggle('open');
        const closestDesc = target.closest('[data-card-desc]')?.querySelector('.complementary-desc');
        if(closestDesc){
          const maxHeight = closestDesc.scrollHeight;
          if(target.classList.contains('open')){
            closestDesc.style.maxHeight = `${maxHeight}px`;
          }else{
            closestDesc.style.maxHeight = "0px";
          }
        }
      });
    });
  }
  
  
});

function menuHoverEvent() {
  const headerMenuLists = document.querySelectorAll('header-menu > details');
  if(headerMenuLists.length){
    headerMenuLists.forEach(list => {
      //on hover
      list.addEventListener("mouseenter", (e) => {
        e.target.setAttribute('open','');
        if(e.target.querySelector('summary')){
          e.target.querySelector('summary').setAttribute('aria-expanded','true');
        }
      });
      //on hover out
      list.addEventListener("mouseleave", (e) => {
        headerMenuLists.forEach(list => {
          list.removeAttribute('open');
          if(list.querySelector('summary')){
            list.querySelector('summary').setAttribute('aria-expanded','false');
          }
        });
      });
    });
  }
}

function subscriptionForms() {
  const sectionEle = document.querySelectorAll(".shopify-section.subscription-forms, .shopify-section.free-download-form");
  if (sectionEle.length) {
    sectionEle.forEach((section) => {
      const submitBtn = section.querySelectorAll("[data-form-submit]");
      if (submitBtn.length) {
        submitBtn.forEach((btn) => {
          btn.addEventListener("click", function (e) {
            e.preventDefault();
            let form = e.target.closest("form.custom_klaviyo_form");            
            if (form.querySelector('[name="email"]').parentElement.querySelector(".form_error_message")) {
              form.querySelector('[name="email"]').parentElement.querySelector(".form_error_message").textContent = ``;
            }
            
            if (form) {
              let formId = `#${form.id}`;
              let data = new FormData(form);
              let serializeData = serialize(data);
              //console.log("formId >>", formId, 'serializeData >>',serializeData);
              if (validateEmail(serializeData.email)) {
                console.log("email validated");
                submitData(serializeData, form);
                form.reset();
              } else {
                if (form.querySelector('[name="email"]').parentElement.querySelector(".form_error_message")) {
                  form.querySelector('[name="email"]').parentElement.querySelector(".form_error_message").textContent = `Enter a valid email address`;
                  return false;
                }
              }
            }
            
          });
        });
      }
    });
  }
}

function validateEmail(value) {
  let mailRegularExpression = /^[a-zA-Z0-9._#%+\-!$&'*\/=?^`{|}~]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return mailRegularExpression.test(value);
}


function submitData(values, form) {
  const options = {
    method: "POST",
    headers: { revision: "2023-10-15", "content-type": "application/json" },
    body: JSON.stringify({
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              id: "",
              attributes: {
                email: values.email,
                first_name: values.firstName
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: values.listId
            }
          }
        }
      }
    })
  };
  //console.log('options >>',options);
  fetch("https://a.klaviyo.com/client/subscriptions/?company_id=WQJ4FS",options)
  .then((response) => {
    if (response.status == 202) {
      console.log("success submitting -->",response);
      if(form.closest('[data-form-content]').querySelector('.form_confirmation_msg')){
        form.closest('[data-form-content]').querySelector('.form_confirmation_msg').classList.remove('hidden');
        form.closest('.form-content').classList.add('hidden');

        //download file if have
        if(form.closest('[data-form-content]').querySelector('input[name="download"]')){
          console.log("Started download file")
          setTimeout(() => {
            window.open(values.download, '_blank', 'noopener, noreferrer');
          });
          if (typeof gtag == 'function') {
            gtag('event', 'free_download');                        
          }
        }
        
      }
    } else {
      console.log("Response Status: " + response.status);
    }
  })
  .catch((err) => console.error(err));
}

function serialize(data) {
  let obj = {};
  for (let [key, value] of data) {
    if (obj[key] !== undefined) {
      if (!Array.isArray(obj[key])) {
        obj[key] = [obj[key]];
      }
      obj[key].push(value);
    } else {
      obj[key] = value;
    }
  }
  return obj;
}

function getSeachQueryString(key) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(key);
}

function productMediaGallery() {
  let meidaGallerySwiper = document.querySelector('[data-media-gallery-carousel] [data-gallery-slider]');
  if(meidaGallerySwiper){
    gallerySwiperInit = new Swiper(meidaGallerySwiper, {
      effect: 'fade',
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      pagination: {
        el: "[data-gallery-slider] .swiper-pagination",
        clickable: true,
      },
      on: {
        transitionStart: function(){
          const allVideos = [...meidaGallerySwiper.querySelectorAll('video, iframe')];
          if(allVideos.length) window.pauseAllMedia();
        },
        
        transitionEnd: function(){
          const activeIndex = gallerySwiperInit.activeIndex;
          const activeSlide = meidaGallerySwiper.querySelectorAll('.swiper-slide')[activeIndex];
          const activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
          if(activeSlideVideo) activeSlideVideo.play();
          //for external video
          const activeSlideIframe = activeSlide.getElementsByTagName('iframe')[0];
          if(activeSlideIframe){
            let iframeSrc = activeSlideIframe.getAttribute('src');
            if(iframeSrc.includes('?autoplay=0')){
              let newSrc = iframeSrc.replace('?autoplay=0','?autoplay=1&muted=1');
              activeSlideIframe.setAttribute('src',newSrc);
            }
            if(iframeSrc.includes('vimeo.com')){
              activeSlideIframe.contentWindow.postMessage('{"method":"play"}', '*');
            }else{
              activeSlideIframe.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
            }
          }
        }
      }
    });
  }
}

function toggleAccordion(element) {
  const content = element.closest('.content-container')?.querySelector(".accordion__content");
  if(content){
    element.closest('.content-container').classList.toggle('open');
    if(element.closest('.content-container').classList.contains('open')){
      content.style.maxHeight = content.scrollHeight + "px";
    }else{
      content.style.maxHeight = "0px";
    }
  }
}

function imageWithTextSection() {
  let imagesEle = document.querySelectorAll('.image-slider-with-text-section [data-image-slider]');
  if(imagesEle.length){
    imagesEle.forEach(imgsSlide => {
      let swiper = new Swiper(imgsSlide, {
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        pagination: {
          el: imgsSlide.querySelector(".swiper-pagination"),
          type: "fraction"
        },
        navigation: {
          nextEl: imgsSlide.querySelector(".swiper-button-next"),
          prevEl: imgsSlide.querySelector(".swiper-button-prev")
        }
      });

      if(imgsSlide.querySelector('[data-play-pause]')){
        imgsSlide.querySelector('[data-play-pause]').addEventListener('click',(e) => {
          e.preventDefault();
          if(e.target.closest('[data-play-pause]').classList.contains('play')){
            e.target.closest('[data-play-pause]').classList.add('pause');
            e.target.closest('[data-play-pause]').classList.remove('play');
            if(swiper) swiper.autoplay.stop();
          }else{
            e.target.closest('[data-play-pause]').classList.add('play');
            e.target.closest('[data-play-pause]').classList.remove('pause');
            if(swiper) swiper.autoplay.start();
          }
        });
      }
    });
  }
}

function imageSliderWithTextInfoSection() {
  let imagesEle = document.querySelectorAll('.image-slider-with-text-info-section [data-image-slider]');
  if(imagesEle.length){
    imagesEle.forEach(imgsSlide => {
      let swiper = new Swiper(imgsSlide, {
        slidesPerView: 1,
        pagination: {
          el: imgsSlide.querySelector(".swiper-pagination"),
          clickable: true
        },
      });
    });
  }
}

function slideShowSliderSection() {
  let slideEle = document.querySelectorAll('.slideshow-slider-section [data-slideshow-slider]');
  if(slideEle.length){
    slideEle.forEach(slide => {
      let swiper = new Swiper(slide, {
        slidesPerView: 1,
        effect: 'fade',
        navigation: {
          nextEl: slide.querySelector(".swiper-button-next"),
          prevEl: slide.querySelector(".swiper-button-prev")
        }
      });
    });
  }
}


function relatedBlogSlider() {
  let slideEle = document.querySelectorAll('.related-blog-post-section [data-related-blog-slider]');
  if(slideEle.length){
    slideEle.forEach(slide => {
      let swiper = new Swiper(slide, {
        slidesPerView: 1.3,
        spaceBetween: 20,
        navigation: {
          nextEl: slide.querySelector(".swiper-button-next"),
          prevEl: slide.querySelector(".swiper-button-prev")
        },
        breakpoints: {
          750: {
            slidesPerView: 2
          },
          990: {
            slidesPerView: 3
          },
        }
      });
    });
  }
}


// This will only render in the theme editor
if (Shopify.designMode) {
   document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener('shopify:section:load', function(){
      
      const productMediaGalleryEle = event.target.closest('.main-product-section') || null;
      if(productMediaGalleryEle && productMediaGalleryEle.querySelector('[data-media-gallery-carousel]')){
        productMediaGallery();
      }

      const slideShowSliderEle = event.target.closest('.slideshow-slider-section') || null;
      if(slideShowSliderEle && slideShowSliderEle.querySelector('[data-slideshow-slider]')){
        slideShowSliderSection();
      }

      const relatedBlogSliderEle = event.target.closest('.related-blog-post-section') || null;
      if(relatedBlogSliderEle && relatedBlogSliderEle.querySelector('[data-related-blog-slider]')){
        relatedBlogSlider();
      }

      const imageSliderWithTextInfoSectionEle = event.target.closest('.image-slider-with-text-info-section') || null;
      if(imageSliderWithTextInfoSectionEle && imageSliderWithTextInfoSectionEle.querySelector('[data-image-slider]')){
        imageSliderWithTextInfoSection();
      }
      
    });
  });
}
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


